<template>
  <div class="header-apr">
      <Tables ref="tableInqueryQmaLv"
          :columns="colunas"
          :showSearch="false"
          :showPrint="false"
          :showDownload="false"
          :showFullscreen="false"
          :newHeaderStatus="true"
          v-on:Load="onLoad"
          style="font-family: 'Segoe UI'; font-size: 14px">
          <template v-for="(obj,index) in listaLv">
            <tr :key="'row-'+index">
              <td class="rev-cell">
                <template v-if="obj.temFilhos">
                  <!-- Linha principal do QMA com filhos é um AGRUPAMENTO VIRTUAL.
                       Só mostra o toggle (+/-) sem número — o "0" aparece dentro do expand
                       como qualquer outro filho. -->
                  <span class="rev-toggle" @click.stop="toggleCadeia(obj)">
                    ({{ cadeiaExpandida[obj.id] ? '-' : '+' }})
                  </span>
                </template>
                <template v-else>
                  {{ obj.numeroRevisao || 0 }}
                </template>
              </td>
              <TableColumn
              v-on:Edit="onSelect(obj)"
              :IsText="true"
              :value="obj.codigoTemplate"></TableColumn>
              <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.codigoObra"></TableColumn>
              <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.codigoReferencia"></TableColumn>
              <TableColumn
              v-on:Edit="onSelect(obj)"
              :newState="true"
              :colorStatus="obj.colorStatus"
              :descriptionNewStatus="obj.descricaoStatus"
              :fontColorStatus="obj.colorFonte"
              style="font-weight: bold;"></TableColumn>
              <TableColumn
              v-on:Edit="onSelect(obj)"
              :IsText="true"
              :value="obj.responsavel"></TableColumn>
              <TableColumn
              v-on:Edit="onSelect(obj)"
              :IsText="true"
              :value="obj.dataCriacao"></TableColumn>
              <td class="cabec-toggle-cell">
                <span v-if="obj.cabecalhos && obj.cabecalhos.length"
                  :id="'cabec-trig-' + obj.id"
                  class="cabec-toggle"
                  tabindex="0"
                  title="Dados do cabeçalho"
                  @click.stop="abrirCabec(obj.id)">
                  📋
                </span>
              </td>
              <TableColumn :IsDocumentActions="true"
              :HasDownload="obj.statusQma !== 0"
              :HasDetails="false"
              :HasAssociar="exigeVinculoSap(obj.codigoQMATemplate)"
              :AssociarUnido="obj.temVinculoSap"
              :HasDocumentDelete="!obj.temFilhos && hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)"
              style="justify-content: center;display: flex; color: #008144;"
              v-on:Download="InformaoesPdfQma(obj, obj.temFilhos ? 'agrupado' : 'individual')"
              v-on:Associar="$refs.modalUnirSap.open(obj.id)"
              v-on:Delete="softDeleteQMA(obj)"
              ></TableColumn>
            </tr>
            <tr v-if="cadeiaExpandida[obj.id]" :key="'cadeia-'+index">
              <td colspan="9" style="padding:0;">
                <div class="cadeia-container">
                  <div v-if="loadingCadeia[obj.id]" class="cadeia-loading">Carregando cadeia...</div>
                  <template v-else-if="cadeiaData[obj.id]">
                    <div v-for="(filho, ci) in cadeiaData[obj.id]" :key="ci"
                      class="cadeia-row"
                      :class="{ 'cadeia-row-atual': filho.isAtual && filho.numeroRevisao > 0 }"
                      @click="onSelect(filho)">
                      <span class="cadeia-rev">Rev. {{ filho.numeroRevisao }}</span>
                      <span class="cadeia-status" :style="{ backgroundColor: filho.colorStatus, color: filho.colorFonte }">{{ filho.statusQMADescricao }}</span>
                      <span class="cadeia-data">{{ filho.dataCriacaoFormatada }}</span>
                      <span v-if="filho.statusQMA !== 0" class="cadeia-download" @click.stop="InformaoesPdfQma(filho, 'individual')" title="Baixar PDF">
                        <i class="fas fa-download"></i>
                      </span>
                      <!-- Unir com SAP é ação da CASA, não de cada revisão — fica só na linha
                           principal (coluna Associar, acima). Uma revisão por vez aqui dentro
                           não fazia sentido: a união é a mesma pra qualquer revisão da casa. -->
                      <!-- Delete por revisão: aparece em qualquer status, em todos os itens
                           da cadeia expandida. Só não aparece na linha-pai agrupadora. -->
                      <span v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)" class="cadeia-delete" @click.stop="softDeleteQMA(filho, obj)" title="Excluir revisão">
                        <i class="fas fa-trash"></i>
                      </span>
                    </div>
                  </template>
                </div>
              </td>
            </tr>
          </template>
      </Tables>
      <!-- Popovers de cabeçalho FORA da tabela: dentro de <tbody> são HTML inválido e o
           browser reposiciona (foster parenting), quebrando a associação com o trigger de
           forma imprevisível. Os triggers (spans com id cabec-trig-) ficam nas <td>. -->
      <template v-for="obj in listaLv">
        <b-popover
          v-if="obj.cabecalhos && obj.cabecalhos.length"
          :key="'pop-'+obj.id"
          :target="'cabec-trig-' + obj.id"
          triggers="manual"
          placement="left"
          boundary="window"
          container="body"
          custom-class="cabec-popover"
          @hidden="onCabecHidden(obj.id)">
          <CabecalhoChips :cabecalhos="obj.cabecalhos" />
        </b-popover>
      </template>
      <inqueryPdfQma ref="inqueryPdfQma" :qma="qma" :propPdf="propPdf" :selectedQma="selectedQma" :dataGeracao="dataGeracao"></inqueryPdfQma>
      <ModalUnirSap ref="modalUnirSap" @united="onLoad"></ModalUnirSap>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import collapseApr from '@/views/private/apr/registerApr/components/collapseapr/collapseApr.vue'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery'
import { loading, toast } from '@/shared/utils/UIHelper'
import VueHtml2pdf from 'vue-html2pdf'
import inqueryPdfQma from '@/views/private/qma/inqueryQma/components/details/inqueryPdfQma/inqueryPdfQma.vue'
import CabecalhoChips from '@/views/private/qma/inqueryQma/components/cabecalhoChips/cabecalhoChips.vue'
import ModalUnirSap from '@/views/private/qma/inqueryQma/components/modalUnirSap/modalUnirSap.vue'
import QmaRepository from '@/shared/http/repositories/business/qmarepository'
import { exigeVinculoSap } from '@/shared/utils/qmaTemplate'
import Vue from 'vue'

export default {
  name: 'inqueryQmaLvTable',
  mixins: [ActionsForm],
  components: {
    HeadDetailsGama,
    collapseApr,
    VueHtml2pdf,
    inqueryQmaRepository,
    inqueryPdfQma,
    CabecalhoChips,
    ModalUnirSap
  },
  props: ['qma'],
  data () {
    return {
      colunas: ['VERIFICAÇÃO', 'CÓD. LV', 'Código Obra', 'Descrição Obra', 'STATUS', 'RESPONSÁVEL', 'DATA INICIAL', 'CABEÇALHO', 'AÇÕES'],
      listaLv: [],
      formSearch: {},
      form: {
        categoria: null,
        descricao: null
      },
      isTechnical: false,
      nomeArquivo: '',
      dataFormatada: null,
      listMidia: [],
      dataRelatorio: null,
      dataInicioFormatado: null,
      dataFimFormatado: null,
      idPdf: false,
      propApr: null,
      assinaturaList: [],
      midiapdf: null,
      midiapdfList: [],
      aprSelected: {
        arquivoID: null,
        arquivoNome: '',
        atividade: '',
        cidade: '',
        codigoAtividade: '',
        colorBackgroundStatusApr: '',
        colorFontStatusApr: '',
        dataExecucaoAPR: null,
        dataExecucaoAPRFormatada: '',
        dataValidadeAPR: null,
        dataValidadeAPRFormatada: 'null',
        descricaoAtividade: '',
        endereco: '',
        estado: '',
        numero: '',
        id: null,
        local: '',
        matricula: null,
        obraid: null,
        offline: null,
        offlineDescricao: '',
        referenciaObra: '',
        responsavel: '',
        revisao: '',
        status: null,
        statuApr: null,
        statuaAPRDescricao: '',
        signatureResponsable: '',
        signatureResponsabletype: null,
        signatureTechnical: '',
        signatureTechnicaltype: null,
        signatureClient: '',
        signatureClienttype: null,
        type: null
      },
      propPdf: {},
      selectedQma: {},
      dataGeracao: null,
      cadeiaExpandida: {},
      cadeiaData: {},
      loadingCadeia: {},
      activeCabecId: null,
      restaurarPagina: true,
      buscaIniciada: false
    }
  },

  watch: {
  },

  mounted () {
    // Load inicial da grid é disparado pelo filtro (unico disparador — evita a corrida
    // entre um fetch sem-filtro daqui e o fetch filtrado do restore). Paginação continua
    // via evento Load do <Tables> -> onLoad.
    document.addEventListener('click', this.onDocClickCabec)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onDocClickCabec)
  },
  methods: {
    exigeVinculoSap,
    onLoad () {
      // ActionsForm.mounted() chama onLoad() no mount. Sem esse guard, dispara um
      // GetAllQma sem filtro (formSearch vazio = todos os registros) que corre contra
      // o Search filtrado do restore e o sobrescreve. Só carrega via onLoad depois
      // que o filtro rodou ao menos uma vez (= paginação real).
      if (!this.buscaIniciada) return
      this.GetAllQma()
    },
    onSearch () {
      this.buscaIniciada = true
      // 1o load após montar (voltou do detalhe) → restaura a página salva.
      // BUSCAR/LIMPAR depois disso = filtro novo → página 1.
      let page = 1
      if (this.restaurarPagina) {
        this.restaurarPagina = false
        page = this.lerPaginaSalva()
      }
      this.$refs.tableInqueryQmaLv.pagingIndex = page
      this.$refs.tableInqueryQmaLv.currentPage = page
      this.GetAllQma()
    },
    // Página divide a chave do filtro (inqueryQmaFilter): filtro grava os campos,
    // tabela grava a página. Assim voltar do detalhe mantém filtro E página.
    chavePersistencia () {
      return `zc-qma-inquery-filter-${this.qma}`
    },
    lerPaginaSalva () {
      try {
        const raw = window.sessionStorage.getItem(this.chavePersistencia())
        if (!raw) return 1
        const s = JSON.parse(raw)
        return (s && s.page && s.page > 0) ? s.page : 1
      } catch (e) {
        return 1
      }
    },
    salvarPagina () {
      try {
        const key = this.chavePersistencia()
        const raw = window.sessionStorage.getItem(key)
        const s = raw ? (JSON.parse(raw) || {}) : {}
        s.page = this.$refs.tableInqueryQmaLv.pagingIndex
        window.sessionStorage.setItem(key, JSON.stringify(s))
      } catch (e) {
        // best-effort
      }
    },
    onSelect (value) {
      if (value.temFilhos) return
      this.$router.push(`/QMA/Consulta/LV/Detalhes?Detalhes=${value.id}`)
    },
    GetAllQma () {
      loading.push()
      this.formSearch.Fluxo = this.qma
      return inqueryQmaRepository.GetAllLvPitPivs(this.$refs.tableInqueryQmaLv.pagingLimit, this.$refs.tableInqueryQmaLv.pagingIndex, this.formSearch)
        .then((Response) => {
          loading.pop()
          this.$refs.tableInqueryQmaLv.LoadAllByData(Response)
          this.listaLv = Response.data.data
          this.salvarPagina()
        })
        .catch((err) => {
          loading.pop()
          console.log(err)
        })
    },
    InformaoesPdfQma (value, modo = 'individual') {
      this.dataGeracao = new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
      loading.push()
      this.selectedQma = value
      const chamada = modo === 'agrupado'
        ? QmaRepository.InformaoesPdfQmaAgrupado({QMAId: value.id, fluxo: this.qma})
        : QmaRepository.InformaoesPdfQmaIndividual({QMAId: value.id, fluxo: this.qma})
      chamada
        .then(Response => {
          this.generatePDF(value, Response.data, this.qma)
          loading.pop()
        })
        .catch((err) => {
          loading.pop()
          console.log(err)
        })
    },
    generatePDF (value, obj, qma) {
      this.$refs['inqueryPdfQma'].onLoad(value, obj, qma)
    },
    abrirCabec (id) {
      // Abertura manual via evento (bv::show) — o trigger nativo 'click blur' do
      // b-popover dessincroniza dentro da tabela e o clique às vezes fecha em vez de abrir.
      if (this.activeCabecId === id) {
        this.$root.$emit('bv::hide::popover', 'cabec-trig-' + id)
        this.activeCabecId = null
        return
      }
      if (this.activeCabecId) {
        this.$root.$emit('bv::hide::popover', 'cabec-trig-' + this.activeCabecId)
      }
      this.$root.$emit('bv::show::popover', 'cabec-trig-' + id)
      this.activeCabecId = id
    },
    onCabecHidden (id) {
      if (this.activeCabecId === id) this.activeCabecId = null
    },
    onDocClickCabec (e) {
      // Fecha ao clicar fora. Clique no ícone tem @click.stop (não chega aqui);
      // clique dentro do popover (renderizado no body) é ignorado.
      if (!this.activeCabecId) return
      if (e.target.closest && e.target.closest('.popover')) return
      this.$root.$emit('bv::hide::popover', 'cabec-trig-' + this.activeCabecId)
      this.activeCabecId = null
    },
    toggleCadeia (obj) {
      const id = obj.id
      const expandido = this.cadeiaExpandida[id]
      Vue.set(this.cadeiaExpandida, id, !expandido)
      if (!expandido && !this.cadeiaData[id]) {
        Vue.set(this.loadingCadeia, id, true)
        QmaRepository.GetCadeiaCorrecao(id)
          .then(response => {
            Vue.set(this.cadeiaData, id, response.data)
            Vue.set(this.loadingCadeia, id, false)
          })
          .catch(() => {
            Vue.set(this.loadingCadeia, id, false)
          })
      }
    },
    softDeleteQMA (obj, paiAgrupado) {
      loading.push()
      inqueryQmaRepository.SoftDeleteQMA(obj.id)
        .then(() => {
          loading.pop()
          toast.success('QMA excluído com sucesso.')
          // Quando o delete é em um filho da cadeia expandida, invalidamos o cache
          // de cadeiaData[paiId] e reabrimos o expand após a listagem recarregar.
          // Sem isso, o expand exibe dados velhos (filho excluído ainda visível) até F5.
          const paiId = paiAgrupado && paiAgrupado.id
          const eraExpandido = !!(paiId && this.cadeiaExpandida[paiId])
          if (paiId) {
            Vue.delete(this.cadeiaData, paiId)
            Vue.delete(this.loadingCadeia, paiId)
            Vue.delete(this.cadeiaExpandida, paiId)
          }
          this.GetAllQma().then(() => {
            if (eraExpandido) {
              const paiAtualizado = this.listaLv && this.listaLv.find(p => p.id === paiId && p.temFilhos)
              if (paiAtualizado) {
                this.toggleCadeia(paiAtualizado)
              }
            }
          })
        })
        .catch((err) => {
          loading.pop()
          toast.error(err.response && err.response.data ? err.response.data : 'Erro ao excluir QMA.')
        })
    }
  }
}

</script>

<style scoped>
.title-checklist,
.title-risk,
.title-medias,
.title-signature {
  font-size: 16px;
  color: #008144;
  font-family: 'Segoe UI';
  font-weight: bold;
  break-inside: avoid;
  break-before: avoid;
}
.lfAnalysis {
  display: flex;
  flex-direction: row;
}
.statusTemplate {
  font-size: 14px;
  font-weight: bold;
}
.analysisRisk{
  display: flex;
  align-items: center;
  flex-direction: row;
  background-color: #F4F4F4;
  padding: 1rem;
  gap: 1rem;
  border-radius: 10px;
  justify-content: space-between;
}
.iconHat{
  background-color: #e8e8e8;
  border-radius: 5px;
}
.titleNumberApr{
  font-family: 'Segoe UI';
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.addressApr, .addressDiv{
  display: flex;
}

.responsableApr,
.dateExpire,
.dateApr {
  display: flex;
}

.dateResponsable{
  display: flex;
  gap: 1rem;
  justify-content: space-between;
}
.font-info {
  font-weight: bold;
}
.font-title, .font-info {
  font-family: 'Segoe UI';
  font-size: 14px;
}
.revisao{
  color: #008144;
  font-weight: bold;
  font-family: 'Segoe UI';
  font-size: 16px;
}
.numberApr, .numbreRevisao{
  display: flex;
  align-items: center;
}
.numbreRevisao {
  justify-content: flex-end;
}
.title-template,
/* .analysis-template, */
.container_ocorrencias,
.causa_raiza_result,
.title-signature,
.signaturelists{
  break-inside: avoid;
}
.checklist {
  break-after: avoid;
}
.container-pdf{
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 10px;
  font-family: 'Segoe UI';
  font-weight: 500;
}
.title-template {
  display: flex;
  flex-direction: column;
  background-color: #F4F4F4;
  padding: 1rem;
  gap: 1rem;
  border-radius: 10px;
}
.info-pdf {
  display: flex;
}
.header-apr {
    background-color: white;
    height: 100%;
}
#impor-ex-price {
display: none;
}
.novoTemplate {
    padding: 0.5rem 3rem 0.5rem 3rem
}
.header-title {
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.btn-generate-lote {
    height: 2rem;
    padding: 0 1rem;
    background: #008144;
    color: white;
    border-radius: 4px;
    border: none;
    font-size: 12px;
}
.btn-generate-lote:hover {
    background: #024d2a;
}
.button-cancel,
.button-save {
  margin-top: 10;
  font-size: 12PX;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}

.container_cancel_save {
  justify-content: center;
  width: 100%;
  margin-top: 1.5rem;
  column-gap: 10px;
}

.button-cancel {
  background-color: #b60000;
  color: white;
}
.button-save {
  background-color: darkgreen;
  color: white;
}
.size-logo-inco-pdf {
  height: 50px;
  width: 250px;
}
.pdf-header {
  margin-bottom: 1rem;
  height: 7vh;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 25px;
  padding-right: 25px;
  background: #e4e5e6;
}
.conteiner_pdf_grafico{
      padding: 1rem;
}
.container_ocorrencias_filtradas {
  width: 100%;
  height: 2rem;
  border-radius: 5px 5px 0 0;
  background: #008144;
  display: flex;
  justify-content: space-around;
}
.font{
        color: #FFF;
        font-family:'Segoe UI';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .container_ocorrencias {
      width: 100%;
      margin: 1rem 0;
      display: flex;
      justify-content: space-around;
    }
    .causa_raiza_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
.rev-cell {
  text-align: center;
  vertical-align: middle;
  padding: 4px;
  font-family: 'Segoe UI';
  font-size: 14px;
}
.rev-toggle {
  cursor: pointer;
  color: #1939b7;
  font-weight: bold;
  margin-left: 4px;
  user-select: none;
}
.cabec-toggle-cell {
  text-align: center;
  vertical-align: middle;
  width: 36px;
}
.cabec-toggle {
  cursor: pointer;
  font-size: 14px;
  user-select: none;
  padding: 4px 6px;
  display: inline-block;
  opacity: 0.55;
  transition: opacity 0.15s;
}
.cabec-toggle:hover {
  opacity: 1;
}
.cadeia-container {
  padding: 8px 16px 8px 48px;
  background-color: #fafafa;
  border-top: 1px solid #e0e0e0;
}
.cadeia-row {
  display: flex;
  gap: 24px;
  align-items: center;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-family: 'Segoe UI';
  font-size: 13px;
}
.cadeia-row:hover { background-color: #f0f0f0; }
.cadeia-row-atual { background-color: #e8f5e9; font-weight: bold; }
.cadeia-rev { width: 70px; color: #008144; font-weight: bold; }
.cadeia-status { min-width: 130px; font-weight: bold; padding: 2px 10px; border-radius: 4px; text-align: center; }
.cadeia-data { min-width: 140px; color: #333; }
.cadeia-download { cursor: pointer; color: #008144; padding: 4px 8px; font-size: 14px; }
.cadeia-download:hover { color: #024d2a; }
.cadeia-delete { cursor: pointer; color: #c0392b; padding: 4px 8px; font-size: 14px; }
.cadeia-delete:hover { color: #7d1f15; }
.cadeia-loading { text-align: center; font-family: 'Segoe UI'; font-size: 12px; color: #888; padding: 8px; }
</style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/inqueryQmaLv/components/inqueryQmaLvTable/inqueryQmaLvTable.vue